import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
import { Partido } from 'src/app/models/partido';
import { Quiniela } from 'src/app/models/quiniela';
import { Jugador } from 'src/app/models/jugador';
import { QuinielaJugada } from 'src/app/models/quiniela-jugada';
import { QuinielasService } from 'src/app/services/quinielas.service';
import { PartidosService } from 'src/app/services/partidos.service';
import { JugadorService } from 'src/app/services/jugadores.service';
import { QuinielaJugadaService } from 'src/app/services/quiniela-jugada.service';
import { PuntajeService } from 'src/app/services/puntaje.service';
import { JugadoresPageComponent } from '../admin/jugadores-page/jugadores-page.component';
import { TablaService } from 'src/app/services/tabla.service';
import { Tabla } from 'src/app/models/tabla';
import Swal from 'sweetalert2';
import { DocumentChangeAction } from '@angular/fire/firestore';

@Component({
  selector: 'app-tabla-page',
  templateUrl: './tabla-page.component.html',
  styleUrls: ['./tabla-page.component.css']
})
export class TablaPageComponent implements OnInit {
  idQuiniela: string
  quiniela: Quiniela
  isLoading = true;
  isIniciando = true;
  jugadores: Array<Jugador> = [];

  constructor(
    private rutaActiva: ActivatedRoute,
    private puntajeService: PuntajeService,
    private QuinielasService: QuinielasService,
    private PartidosService: PartidosService,
    private JugadoresService: JugadorService,
    private QuinielaJugadaService: QuinielaJugadaService,
    private router: Router,
    private toastr: ToastrService,
    private TablaService: TablaService,
  ) { }

  ngOnInit(): void {
    // Obtener por parametro de URL de la Quiniela
    this.idQuiniela = this.rutaActiva.snapshot.params.id;
    console.log(this.idQuiniela)

    // Obtener la Quiniela
    this.getQuinielaById();

    // Haciendo desaparecer el Futbolista luego de 3 segundos
    setTimeout(() => {
      this.isIniciando = false;
    }, 3000);

  }

  getQuinielaById(): void {
    this.QuinielasService.getQuiniela(this.idQuiniela).subscribe((item) => {
      this.quiniela = {
        $key: item.payload.id,
        ...item.payload.data(),
      };
      // Obtener los Jugadores
      this.getAllJugadoresByIdQuiniela();
    });
  }

  getAllJugadoresByIdQuiniela(): void {
    this.isLoading = true;

    // Obtener la tabla a partir de un ID o $Key de la tabla
    this.TablaService.getAllTablasByIdQuiniela(this.quiniela.$key).subscribe((items) => {
      var tabla = items.map(
        (item) =>
        ({
          ...item.payload.doc.data(),
          $key: item.payload.doc.id,
        } as Tabla)
      );

      // Si la longitud de la peticion a DB es diferente a 0 significa que si existe esa tabla en DB 
      if (tabla.length != 0) {
        this.jugadores = tabla[0].tabla;

        // Ordenar los Jugadores por sus puntajes (Menor a Mayor)
        this.jugadores.sort(function (x, y) {
          return x.puntaje - y.puntaje;
        });
        // Ejecutando un reverse para que queden de Mayor a Menor
        this.jugadores.reverse();
        
      }
      this.isLoading = false; 
    });
  }

  estaActivo(elemento) {
    if (elemento.confirmado == true) {
      console.log(elemento)
      return elemento;
    }
  }

  buscar() {
    console.log("asd")
    var input, filter, table, tr, td, i, txtValue;
    input = document.getElementById("buscarInput");
    filter = input.value.toUpperCase();
    table = document.getElementById("tablePartidos");
    tr = table.getElementsByTagName("tr");
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByTagName("td")[1];
      if (td) {
        txtValue = td.textContent || td.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          tr[i].style.display = "";
        } else {
          tr[i].style.display = "none";
        }
      }
    }
  }

  descargarCopiaSeguridad(keyQuiniela: string) {
    this.JugadoresService.getAllJugadoresByIdQuiniela(keyQuiniela).subscribe((jugadores: DocumentChangeAction<Jugador>[]) => {
      const resumenes: {jugador: any; partidos: any[]}[] = [];
  
      jugadores.forEach((jugador) => {
        const jugadorData = jugador.payload.doc.data() as Jugador;
        this.QuinielaJugadaService.getAllPartidosByIdJugador(jugadorData.$key).subscribe((partidos: DocumentChangeAction<QuinielaJugada>[]) => {
          const partidosData = partidos.map(p => ({
            contrincante1: p.payload.doc.data().contrincante1,
            resultado1: p.payload.doc.data().resultado1,
            contrincante2: p.payload.doc.data().contrincante2,
            resultado2: p.payload.doc.data().resultado2
          })).map(this.limpiarContrincantes);
  
          const resumenJugador = {
            jugador: {
              nombre: jugadorData.nombre,
              apellido: jugadorData.apellido
            },
            partidos: partidosData
          };
  
          resumenes.push(resumenJugador);
          
          // Si ya se han procesado todos los jugadores, se genera el archivo
          if (resumenes.length === jugadores.length) {
            const fecha = new Date().toISOString().split('T')[0];
            const nombreArchivo = `${this.quiniela.titulo}_${fecha}.txt`;
            this.crearArchivoTextoQuiniela(nombreArchivo, resumenes);
          }
        });
      });
    });
  }
  
  limpiarContrincantes(partido: any) {
    partido.contrincante1 = partido.contrincante1.replace(/\t/g, '');
    partido.contrincante2 = partido.contrincante2.replace(/\t/g, '');
    return partido;
  }

  crearArchivoTextoQuiniela(nombreArchivo: string, resumenes: any[]) {
    let texto = `COPIA DE SEGURIDAD: \n\n`;
    texto += `JUGADORES\n\n`;

    resumenes.forEach((resumen) => {
      texto += `JUGADOR\n`;
      texto += `Nombre: ${resumen.jugador.nombre}\n`;
      texto += `Apellido: ${resumen.jugador.apellido}\n\n`;

      texto += `PARTIDOS\n`;
      resumen.partidos.forEach((partido, index) => {
        texto += `${partido.contrincante1} ${partido.resultado1} - ${partido.resultado2} ${partido.contrincante2}\n`;
      });

      texto += '\n';  // Espacio entre los resúmenes de jugadores
    });

    const blob = new Blob([texto], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = nombreArchivo;
    a.click();
    URL.revokeObjectURL(url);
  }
  
  Futbolista: AnimationOptions = {
    path: '/assets/img/futbolista.json',
  };

  animationCreated(animationItem: AnimationItem): void {
    console.log(animationItem);
  }

}
